import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";

const ApproveModal = ({ open, onClose, handleSubmit }) => {
  const [motivo, setMotivo] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(e, motivo);
    setMotivo("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Aprobar solicitud</DialogTitle>
      <DialogContent>
        <DialogContentText>
          ¿Está seguro que desea aprobar la solicitud?
        </DialogContentText>
        <form onSubmit={handleFormSubmit} id="approve-form">
          <TextField
            margin="dense"
            id="motivo"
            name="motivo"
            label="Motivo"
            placeholder="Ingrese aqui el motivo."
            type="text"
            fullWidth
            variant="standard"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value.slice(0, 255))}
            helperText="Hasta 255 caracteres. No es obligatorio."
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Volver</Button>
        <Button type="submit" form="approve-form">
          Aprobar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveModal;
